import apiWorker from '../apiWorker'

const total_connections =  {
    find : () => apiWorker('get', `/v1/api/total_connections`, null, true),
}

export default total_connections;